import React from 'react';
import PropTypes from 'prop-types';

import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import styled from 'styled-components';

const DialogTitleCustom = styled(DialogTitle)`
  font-size: 2.25rem;
  font-weight: bold;
  color: #d9534f;
  margin-bottom: 0;
`;

/**
 * Dialog afficher juste avant l'envoie des commandes vers le serveur,
 * cette modale de dialog s'affiche uniqement si les commandes contienne des
 * warnings ( id de la commande déjà existant dans notre système )
 * @param {Boolean}  isOpen        Statut de la boite de dialog ouvert ou fermer
 * @param {Function} handleClose   Function permettant d'ouvrir ou de fermer la boite de dialog
 * @param {Function}   createBatch   Function permettant de créer un batch de commande
 */
const WarningDialog = ({ isOpen, handleClose, createBatch }) => (
  <div>
    <Dialog open={isOpen} onClose={() => handleClose()}>
      <DialogTitleCustom disableTypography>Attention !</DialogTitleCustom>
      <DialogContent>
        <DialogContentText>
          Vous êtes sur le point d&lsquo;importer des commandes avec des
          références déjà présentes sur votre compte.
          <br />
          <br />
          Êtes-vous sûr de vouloir continuer ?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary" variant="contained">
          Annuler
        </Button>
        <Button
          onClick={() => {
            createBatch();
            handleClose();
          }}
          color="primary"
          variant="contained"
        >
          Continuer
        </Button>
      </DialogActions>
    </Dialog>
  </div>
);

WarningDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  createBatch: PropTypes.func.isRequired
};

export default WarningDialog;
